// extracted by mini-css-extract-plugin
module.exports = {"customWysiwyg":"customWysiwyg_customWysiwyg__AMBZG"};